import { Component, Input } from '@angular/core';
import { News } from '../../shared/interface';

@Component({
  selector: 'app-news-box',
  templateUrl: './news-box.component.html',
  styleUrl: './news-box.component.css'
})
export class NewsBoxComponent {

  @Input() notizia!: News;

}
